import { StackActions, useNavigation } from "@react-navigation/native";
import { Block } from "app/shared/components/blocks/block";
import CustomQRCreator from "app/shared/components/custom-qr-creator/custom-qr-creator";
import CustomQRCreatorUtils from "app/shared/components/custom-qr-creator/custom-qr-creator-utils";
import GlobalViewShot, { GlobalViewShotRef } from "app/shared/components/global-view-shot/global-viewshot.web";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { QueueSpacing } from "app/shared/components/spacing";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { spacing } from "app/shared/styles/spacing";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import { globalShowFuture } from "app/shared/util/future";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { Button, useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { getListAccountSelector } from "../account-management/reducer/selectors";
import { showModal } from "../modal-management/reducer/action";

const QRLibraryList = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const { dispatch, goBack } = useNavigation();
  const isDesktop = useDesktopMediaQuery();
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);
  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("Thư viện QR"),
      onPressSubtitle: () => {},
    },
  ];

  const listAccount = useSelector(getListAccountSelector);
  const account = listAccount?.ACCOUNT[0];

  const onCancel = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const handlerParamsAppFlyer = (action: string) => {
    console.log("handlerParamsAppFlyer");
    // home, download_qr, create_qr
    const paramStatus = {
      success: true,
      failure: false,
    };
    return {
      eventName: "af_my_qr",
      params: {
        af_channel: "ib_rb",
        af_save_my_qr: JSON.stringify(paramStatus),
        af_view_my_qr: action,
      },
    };
  };

  const downloadQR = () => {
    if (!account) {
      dispatchStore(
        showModal({
          modalProps: {
            open: true,
            message: t("COMMON_KHONG_CO_DU_LIEU"),
          },
          modalType: "alert",
        }),
      );
    } else {
      globalViewShotRef.current?.takeViewShot();
    }
    const { eventName, params } = handlerParamsAppFlyer("download_qr");
    pushAppFlyer(eventName, params);
  };

  const onPressGoHome = () => {
    goBack();
    const { eventName, params } = handlerParamsAppFlyer("home");
    pushAppFlyer(eventName, params);
  };

  const onPressGoCreateOtherQR = () => {
    globalShowFuture();
    const { eventName, params } = handlerParamsAppFlyer("create_qr");
    pushAppFlyer(eventName, params);
  };

  const QRDownload = (
    <div style={{ overflow: "hidden", height: 0, width: 0 }}>
      <GlobalViewShot watermark={false} ref={globalViewShotRef}>
        <CustomQRCreator
          value={{
            valueQR: CustomQRCreatorUtils.createStringForQR(account),
            accountName: account?.ACCOUNTNAME,
            accountNumber: account?.ACCOUNTNO,
          }}
          mode="fullsize"
        />
      </GlobalViewShot>
    </div>
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("Thư viện QR")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? spacing.macro : spacing.medium}>
          <Block flex={1} center>
            <CustomQRCreator
              scale={1.5}
              value={{
                accountName: account?.ACCOUNTNAME,
                accountNumber: account?.ACCOUNTNO,
                valueQR: CustomQRCreatorUtils.createStringForQR(account),
              }}
              mode="compact"
            />
          </Block>
          <Block row middle pv={spacing.huge}>
            <Button
              mode="contained"
              labelStyle={{ color: colors.whiteText }}
              style={{ backgroundColor: colors.accent }}
              onPress={downloadQR}>
              {t("ACC_TAI_VE")}
            </Button>
          </Block>
          <Block row middle pv={spacing.huge}>
            <Button mode="contained" style={{ backgroundColor: colors.backgroundForm }} onPress={onPressGoHome}>
              {t("FUNC_TRANG_CHU")}
            </Button>
            <QueueSpacing size="large" />
            <Button mode="contained" style={{ backgroundColor: colors.primary }} onPress={onPressGoCreateOtherQR}>
              {t("QR_TAO_MA_QR_KHAC")}
            </Button>
          </Block>
        </Block>
        {QRDownload}
      </ScrollView>
    </Block>
  );
};

export default QRLibraryList;
